import React, { useEffect } from 'react';
import { Dropdown } from 'semantic-ui-react';
import { NavLink, useLocation } from 'react-router-dom';
import { useTour } from '@reactour/tour';

import { PATH } from 'src/constants/app';
import { useResponsive } from 'ahooks';
import { BarFour } from 'src/components/icons';
import LocalStorage from 'src/utils/LocalStorage';

const menu = [
  // {
  //   name: 'Library',
  //   to: PATH.LIBRARY,
  // },
  // {
  //   name: 'Directory',
  //   to: PATH.DIRECTORY,
  // },
  // {
  //   name: 'Jobs',
  //   to: PATH.JOBS,
  // },
  {
    name: 'Connect',
    to: PATH.CONNECT,
  },
  {
    name: 'FAQs',
    to: PATH.FAQS,
  },
  {
    name: 'Privacy Policy',
    to: PATH.TERM_AND_POLICY,
  },
];

const MenuDropdown = () => {
  const location = useLocation();

  return (
    <Dropdown
      direction="left"
      className="responsive_dropdown"
      icon={null}
      trigger={<BarFour />}
      options={menu.map((m) => {
        return {
          key: m.to,
          text: <NavLink to={m.to}>{m.name}</NavLink>,
          value: m.to,
        };
      })}
      value={location.pathname.split('/')?.[1]}
    />
  );
};

const AppMenu: React.FC = () => {
  const { setIsOpen } = useTour();

  useEffect(() => {
    const { first_logged_in_at } = LocalStorage.authInfo;
    if (first_logged_in_at === null) {
      setIsOpen(true);
    }
  }, []);

  return (
    <nav className="navigation">
      <ul>
        <li id={'home'}>
          <NavLink to={'/'}>Home</NavLink>
        </li>
        {menu.map((m) => {
          return (
            <li id={m.to} key={m.to}>
              <NavLink to={m.to}>{m.name}</NavLink>
            </li>
          );
        })}
      </ul>
    </nav>
  );
};

const ResponsiveMenu = () => {
  const screen = useResponsive();

  return !screen.lg ? <MenuDropdown /> : <AppMenu />;
};

export default ResponsiveMenu;
